import { render } from "./customersoldoutreport.vue?vue&type=template&id=33866359&scoped=true"
import script from "./customersoldoutreport.vue?vue&type=script&lang=js"
export * from "./customersoldoutreport.vue?vue&type=script&lang=js"

import "./customersoldoutreport.vue?vue&type=style&index=0&id=33866359&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33866359"]])

export default __exports__